import React from 'react';
import { Field, CccisdInput, CccisdColorPicker } from 'cccisd-formik';
import IconBin from 'cccisd-icons/bin';
import { ImagePicker } from 'cccisd-laravel-resources';
import { BuilderBlock, reportTemplateBuilder } from 'cccisd-laravel-appdefs';
import style from './style.css';
import widgets from '../widgets';
// import filterFields from '../filterFields.js';

export const initialValues = {
    title: 'Assessment Report',
    header: null,
    footer: null,
    filename: 'assessment_report',
    widgetMargin: '25',
    answerBackgroundColor: '#DAECF7',
    widgets: widgets.reduce((obj, w) => {
        obj[w.handle] = w.builderInitialValues;
        return obj;
    }, {}),
};

const AssessmentReportBuilder = props => {
    const renderImagePickerField = settingsKey => (
        <Field name={settingsKey}>
            {({ form }) => {
                const currVal = form.values[settingsKey];
                return (
                    <>
                        {currVal && <img src={currVal.url} alt={currVal.name} className={style.imagePreview} />}
                        <ImagePicker
                            trigger={
                                <button className="btn btn-secondary" type="button">
                                    {currVal ? 'Change' : 'Select'} Image
                                </button>
                            }
                            onChange={imgMeta => form.setFieldValue(settingsKey, imgMeta)}
                            value={currVal || {}}
                        />
                        {currVal && (
                            <button
                                type="button"
                                className={'btn btn-danger ' + style.removeImage}
                                onClick={() => form.setFieldValue(settingsKey, null)}
                            >
                                <IconBin />
                                &nbsp;&nbsp;Remove
                            </button>
                        )}
                    </>
                );
            }}
        </Field>
    );

    return (
        <>
            <BuilderBlock title="Header" isVisibleOverflow>
                {renderImagePickerField('header')}
            </BuilderBlock>
            <BuilderBlock title="Footer" isVisibleOverflow>
                {renderImagePickerField('footer')}
            </BuilderBlock>
            <BuilderBlock title="Filename" isVisibleOverflow>
                <Field
                    name="filename"
                    component={CccisdInput}
                    label="Download Filename (Do not include file extension)"
                />
            </BuilderBlock>
            <BuilderBlock title="Style Settings" isVisibleOverflow>
                <Field name="widgetMargin" component={CccisdInput} type="number" label="Widget Margin (px)" />
                <Field name="answerBackgroundColor" component={CccisdColorPicker} label="Answer Background Color" />
            </BuilderBlock>
        </>
    );
};

// reportTemplateBuilder is a Formik wrapper which combines the Fields in this component with Filter and Widget Fields.
export default reportTemplateBuilder({ widgets })(AssessmentReportBuilder);
